import React from 'react'
import styled from 'styled-components'
import { FaPlug } from "react-icons/fa6";
import { IoMdAlert } from "react-icons/io";

function DeviceTiles({devices}) {

    const connected = devices?.connected || 0; 
    const disconnected = devices?.disconnected || 0; 
    const warning = devices?.warning || 0; 
    const critical = devices?.critical || 0; 
    return (
    <Container>
        <div className='tag'>
            <div className='title'>Medidores conectados</div>
            <div className='number connected'>{connected}</div>
            <div className='more-info'>{disconnected} {disconnected === 1 ? 'Desconectado' : 'Desconectados'}</div>
            <div className='icon devices'>
                <FaPlug /> 
            </div>
        </div>
        <div className='tag'>
            <div className='title'>Alertas activas</div>
            <div className='number warnings'>{warning}</div>
            <div className='more-info'>{critical} {critical === 1 ? 'Crítica' : 'Críticas'}</div>
            <div className='icon alerts'>
                <IoMdAlert />
            </div>
        </div>
    </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    .tag{
        padding: 10px;
        width: 15rem;
        height: 8vh;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);

        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(3, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        
        .title {
            grid-area: 1 / 1 / 2 / 4;
            color: var(--Color-3, #0000007c);
            font-family: 'Montserrat', sans-serif;
            font-size: .9rem;
            font-style: normal;
            font-weight: 500;
            text-align: center;
            line-height: normal;
            margin: auto auto auto 5px;
            padding: 0;
        }

        .icon {
            grid-area: 1 / 4 / 4 / 5;
            width: 30%;
            height: auto;
            object-fit: cover;
            margin: 0 15% 0 auto;
            padding: 0;

            svg{
                font-size: 24px;
            }

            &.devices{
                color: #2858A2;
            }

            &.alerts{
                color: #FF3B30;
            }
        }

        .number {
            grid-area: 2 / 1 / 3 / 4;
            font-family: 'Montserrat', sans-serif;
            font-size: 1rem;
            font-style: normal;
            font-weight: 800;
            text-align: center;
            line-height: normal;
            margin: auto auto auto 5px;
            padding: 0;
        }

        .more-info{
            grid-area: 3 / 1 / 4 / 4;
            color: var(--Color-3, #0000007c);
            font-family: 'Montserrat', sans-serif;
            font-size: 0.8125rem;
            font-style: normal;
            font-weight: 500;
            text-align: center;
            line-height: normal;
            margin: auto auto auto 5px;
            padding: 0;
        }

        .connected {
            color: var(--Color-2, #2858A2);
        }

        .warnings {    
            color: var(--Color-6, #FF3B30);
        }

    }

`

export default DeviceTiles